import {ToggleButton as MUIToggleButton, Tooltip, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React, {forwardRef} from 'react';

const ToggleButton = forwardRef(
  ({title, placement = 'right', disabled, ...props}, ref) => (
    <Tooltip title={title} placement={placement}>
      <MUIToggleButton
        component={disabled ? 'div' : undefined}
        role="button"
        disabled={disabled}
        ref={ref}
        size="small"
        {...props}
      />
    </Tooltip>
  )
);

ToggleButton.propTypes = {
  title: PropTypes.string,
  placement: PropTypes.string,
  disabled: PropTypes.bool,
};

const StyledToggleButton = styled(ToggleButton)(({theme}) => ({
  '&.MuiToggleButton-root': {
    border: 'none',
    margin: theme.spacing(1, 0),
    borderRadius: theme.shape.borderRadius,
  },
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
}));

export default StyledToggleButton;
